import { render } from "./QuickReservation.vue?vue&type=template&id=18308ec4&ts=true"
import script from "./QuickReservation.vue?vue&type=script&lang=ts"
export * from "./QuickReservation.vue?vue&type=script&lang=ts"

import "./QuickReservation.vue?vue&type=style&index=0&id=18308ec4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__